import React, { useState, useEffect } from "react";
import axios from "axios";
import "./GestionUnidadesVenta.css";

function GestionUnidadesVenta() {
  const [unidades, setUnidades] = useState([]);
  const [nuevaUnidad, setNuevaUnidad] = useState("");
  const [mensaje, setMensaje] = useState("");

  const fetchUnidades = () => {
    fetch("https://panelcomerciantes.lagora.chat/api/getUnidadesVenta.php")
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setUnidades(data);
        } else {
          console.error("⚠️ Error al obtener unidades de venta:", data.error || data);
          setUnidades([]);
        }
      })
      .catch(err => {
        console.error("❌ Error de red al obtener unidades:", err);
        setUnidades([]);
      });
  };

  useEffect(() => {
    fetchUnidades();
  }, []);

  const handleAgregarUnidad = async () => {
    if (!nuevaUnidad.trim()) return;
    try {
      const response = await axios.post("https://lagora.chat/panelcomerciantes/api/addUnidadVenta.php", {
        nombre: nuevaUnidad
      });
      if (response.data.success) {
        setMensaje("Unidad agregada correctamente.");
        setNuevaUnidad("");
        fetchUnidades();
      } else {
        setMensaje("Error al agregar unidad.");
      }
    } catch (error) {
      console.error("Error al agregar unidad:", error);
    }
  };

  const handleToggleVisible = async (id, currentVisible) => {
    try {
      await axios.post("https://lagora.chat/panelcomerciantes/api/editUnidadVenta.php", {
        id,
        visible: currentVisible ? 0 : 1
      });
      fetchUnidades();
    } catch (error) {
      console.error("Error al cambiar visibilidad:", error);
    }
  };

  const handleEliminar = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar esta unidad de venta?")) return;
    try {
      await axios.post("https://lagora.chat/panelcomerciantes/api/deleteUnidadVenta.php", { id });
      fetchUnidades();
    } catch (error) {
      console.error("Error al eliminar unidad:", error);
    }
  };

  return (
    <div className="gestion-unidades-container">
      <h1>Gestión de Unidades de Venta</h1>
      {mensaje && <p>{mensaje}</p>}

      <input
        type="text"
        placeholder="Nueva unidad de venta"
        value={nuevaUnidad}
        onChange={(e) => setNuevaUnidad(e.target.value)}
      />
      <button onClick={handleAgregarUnidad}>Agregar</button>

      <table>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Visible</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {unidades.map((unidad) => (
            <tr key={unidad.id}>
              <td>{unidad.nombre}</td>
              <td>{unidad.visible === 1 || unidad.visible === "1" ? "Sí" : "No"}</td>
              <td>
                <button onClick={() => handleToggleVisible(unidad.id, unidad.visible)}>
                  {unidad.visible ? "Ocultar" : "Mostrar"}
                </button>
                <button onClick={() => handleEliminar(unidad.id)}>Eliminar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default GestionUnidadesVenta;
